module.exports = {
  DATA_MINIMA_PAINEL_EMBARQUE:
    process.env.REACT_APP_DATA_MINIMA_PAINEL_EMBARQUE,
  DATA_MINIMA_DASHBOARD:
    process.env.REACT_APP_DATA_MINIMA_DASHBOARD_PERFORMANCE,
};
